import Phaser from 'phaser';
import MainScene from 'src/app/Scenes/MainScene';
import BaseLevelScene from 'src/app/Scenes/BaseLevelScene';
import { AudioViewerComponent } from 'src/app/audio-viewer/audio-viewer.component';
import { UserAudio } from 'infrastructure/lib/src/models/user-audio';

export class MixTape extends Phaser.Physics.Matter.Sprite {
  static sound: Phaser.Sound.BaseSound;
  birthTime: number;
  minLifeSpan: number = 250; //(ms) Min time before this can be picked up
  public static uploadedAudio: UserAudio[] = [];
  public static previousAudio: UserAudio[] = [];
  public audioMetadata: UserAudio;
  constructor(scene: MainScene | BaseLevelScene, x: number, y: number, metaData: UserAudio, playerScale=1) {
    super(scene.matter.world, x, y, 'cassette');
    this.setName(metaData.s3Path);
    this.scene.add.existing(this);
    const Bodies = new Phaser.Physics.Matter.MatterPhysics(scene).bodies;
    var circleCollider = Bodies.circle(this.x, this.y, 10*playerScale, {
      isSensor: false,
      label: 'audioCollider',
    });
    this.setExistingBody(circleCollider);
    this.setFrictionAir(1);
    this.setScale(playerScale);
    this.setDepth(2);
    this.birthTime = Date.now();
    this.audioMetadata = metaData;
    console.log("MixTape created at: ", x, y, " with metadata: ", metaData);
  }

  static preload(scene) {
    scene.load.image('cassette', 'assets/items/cassetteTape.png')
    // scene.load.audio('pickup', 'assets/audio/pickup.mp3');
  }

  // Retrieve all filenames from public s3 bucket
  public static placeNewAudio(scene: MainScene) {
    if (MixTape.uploadedAudio && MixTape.previousAudio != MixTape.uploadedAudio) {
      // Only add new mix tapes so we don't duplicate
      const newMixTapes: UserAudio[] = MixTape.uploadedAudio.filter(
        (audio) => !MixTape.previousAudio.includes(audio)
      );
      MixTape.previousAudio = MixTape.uploadedAudio;

      // Place properly formatted mix tapes on the main scene
      if (newMixTapes.length > 0) {
        newMixTapes.forEach((audio) => {
          const { x, y } = MixTape.extractCoordsFromFilename(audio.s3Path);
          if (x && y) {
            console.log(`audio: ${audio}`);
            new MixTape(scene, x, y, audio);
          }
        });
      }
    }
  }

  public static extractCoordsFromFilename(fileName: string): {
    x: number;
    y: number;
  } {
    // File name is at the end of the path, so split by / and reverse the split
    const tokens: string[] = fileName.split('/').reverse()[0].split('_');
    if (tokens.length <= 1) {
      return { x: NaN, y: NaN };
    }
    return { x: Number(tokens[0]), y: Number(tokens[1]) };
  }

  pickup() {
    console.log("Attempting to pick up mix tape: ", this.audioMetadata);
    if (Date.now() - this.birthTime >= this.minLifeSpan) {
      // MixTape.sound.play();
      console.log("Picked up mix tape: ");
      console.log(this.audioMetadata);
      AudioViewerComponent.openModal(this.audioMetadata, this.scene as (MainScene));
      this.destroy();
      return true;
    }
    return false;
  }
}
